const Print = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.2251 17.5165C8.2251 17.0746 8.58327 16.7165 9.0251 16.7165H15.0715C15.5133 16.7165 15.8715 17.0746 15.8715 17.5165C15.8715 17.9583 15.5133 18.3165 15.0715 18.3165H9.0251C8.58327 18.3165 8.2251 17.9583 8.2251 17.5165Z"
        fill="#1A1919"
      />
      <path
        d="M9.0251 13.6933C8.58327 13.6933 8.2251 14.0515 8.2251 14.4933C8.2251 14.9351 8.58327 15.2933 9.0251 15.2933H15.0715C15.5133 15.2933 15.8715 14.9351 15.8715 14.4933C15.8715 14.0515 15.5133 13.6933 15.0715 13.6933H9.0251Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5811 2.7039L6.01191 2.70391C5.0178 2.70392 4.21191 3.50981 4.21191 4.50392V20.4947C4.21191 21.4888 5.0178 22.2947 6.01191 22.2947H17.9986C18.9928 22.2947 19.7986 21.4888 19.7986 20.4947V9.98311C19.7986 9.50926 19.6118 9.05451 19.2786 8.71755L13.8611 3.23834C13.523 2.89635 13.0621 2.7039 12.5811 2.7039ZM11.2095 4.30391L6.01191 4.30391C5.90146 4.30392 5.81191 4.39346 5.81191 4.50392V20.4947C5.81191 20.6051 5.90146 20.6947 6.01191 20.6947H17.9986C18.1091 20.6947 18.1986 20.6051 18.1986 20.4947V11.2994H13.0095C12.0154 11.2994 11.2095 10.4936 11.2095 9.49944V4.30391ZM17.9994 9.69944L12.8095 4.45038V9.49944C12.8095 9.6099 12.899 9.69944 13.0095 9.69944H17.9994Z"
        fill="#1A1919"
      />
    </svg>
  );
};

export default Print;
